module.exports = __webpack_public_path__ + "assets/icon-redpack-4cc7b173.png";